<template>
  <div class="info">
    <div class="row d-flex flex-row">
      <div class="ml-md-auto">
        <ul>
          <li>
            <div>Служба расчетов:</div>
            <div><a href="mailto:billing@ic.vrn.ru">billing@ic.vrn.ru</a></div>
            <div>
              тел. <a href="tel:+7(473)260-66-04">+7 (473) 260-66-04</a>
            </div>
          </li>
          <li>
            <div>Техподдержка:</div>
            <div>
              тел. <a href="tel:+7(473)260-60-62">+7 (473) 260-60-62</a>
            </div>
          </li>
          <li>
            <div>Отдел сопровождения юридических лиц:</div>
            <div><a href="mailto:osul@ic.vrn.ru">osul@ic.vrn.ru</a></div>
            <div>тел. <a href="tel:+7(473)260-61-65">+7(473) 260-61-65</a></div>
          </li>
          <li>
            <div>Отдел продаж:</div>
            <div><a href="mailto:market@ic.vrn.ru">market@ic.vrn.ru</a></div>
            <div>
              тел. <a href="tel:+7(473)260-60-61">+7 (473) 260-60-61</a>
            </div>
          </li>
          <li class="mt-4">
            <router-link
              :to="{ name: 'feedback' }"
              class="btn btn-blue text-white"
              >Обратная связь</router-link
            >
          </li>
          <li class="mt-4">
            <a href="https://ktkt.ru/el-podp/" target="_blank">
              <img
                alt="Электронная подпись"
                src="@/assets/img/banner_ECP.png"
                class="img-fluid"
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
.info {
  top: 100px;
  position: fixed;
  margin-left: 1em;
  max-width: 200px;
  width: 12%;
  color: var(--color-grey);
}

.info li {
  margin-top: 1em;
}

.info a:not(:hover) {
  color: var(--color-grey);
}

@media (max-width: 1000px) {
  .info {
    display: none;
  }
}
</style>
